import React, { memo, useMemo } from "react";
import { Button } from "@mui/material";
import { Alert } from "@mui/material";
import { Link } from "react-router-dom";
import LocationBase from "../subscribedLocations/Location";
import { BRAND_CONST, LocSubsStatus } from "@/config/constants";
import RpVirtualListBase from "@/components/virtual/RpVirtualList";

type LocationId = string | number;

type InactiveLocation = {
  id?: LocationId;
  location_name?: string;
  is30DaysLeftToJoinCampaign?: boolean;
  subscriptionStatusType?: string;
  [key: string]: unknown;
};

type InActiveLocationsProps = {
  fallOutSideLocations?: InactiveLocation[];
  unSubscribedLocations?: InactiveLocation[];
  selectedBrand?: {
    id?: string | number;
  };
  campaign?: unknown;
  values?: Record<LocationId, unknown>;
  setFieldValue?: (..._args: unknown[]) => void;
  setFieldError?: (..._args: unknown[]) => void;
  expanded?: unknown;
  setExpanded?: (..._args: unknown[]) => void;
};

const Location = LocationBase as unknown as React.ComponentType<
  Record<string, unknown>
>;
const RpVirtualList = RpVirtualListBase as unknown as React.ComponentType<{
  items?: InactiveLocation[];
  computeItemKey?: (_index: number) => React.Key;
  renderItem?: (_item: InactiveLocation) => React.ReactNode;
}>;

/**
 * @method LocationNotActive
 * @description Render single location. US (Unsubscribed)
 * @param {*} param0
 * @returns
 */
// const LocationNotActive = ({
//   name = "",
//   type = LocSubsStatus.UNSUBSCRIBED,
//   is30DaysLeftToJoinCampaign,
// }) => {
//   const renderMessage = () => {
//     let msg = "Unsubscribed";
//     let lessThan30Msg;
//     if (type === LocSubsStatus.FALLOUT) {
//       msg = "Campaign Dates are Outside Subscription Period";
//       if (is30DaysLeftToJoinCampaign) {
//         lessThan30Msg =
//           "You have less than a month left in your subscription for this location, please renew in order to join this campaign";
//       }
//     }
//     return (
//       <span>
//         {msg}
//         {lessThan30Msg && (
//           <>
//             <br />
//             <small style={{ fontSize: "inherit" }}>{lessThan30Msg}</small>
//           </>
//         )}
//       </span>
//     );
//   };
//   return (
//     <div className="card">
//       <div className="card-body">
//         <div className="row">
//           <div className="col-md-6 mb-2 mb-md-0 location-name">{name}</div>
//           <div className="col-md-6 message d-flex align-items-center justify-content-md-end">
//             <div className="fallOutside">
//               <Icon
//                 component="img"
//                 src={
//                   type === LocSubsStatus.UNSUBSCRIBED
//                     ? STATIC_IMAGES.infoRed
//                     : STATIC_IMAGES.infoYellow
//                 }
//                 sizes="small"
//                 className="mr-2"
//               />
//               {renderMessage()}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

const InActiveLocations = ({
  fallOutSideLocations = [],
  unSubscribedLocations = [],
  selectedBrand,
  campaign,
  values,
  setFieldValue,
  setFieldError,
  expanded,
  setExpanded,
}: InActiveLocationsProps) => {
  const isThereNoInactiveLocations = useMemo(() => {
    return [...fallOutSideLocations, ...unSubscribedLocations].length === 0;
  }, [fallOutSideLocations, unSubscribedLocations]);

  const inactiveLocations = useMemo(() => {
    return [
      ...fallOutSideLocations.map((loc) => ({
        ...loc,
        subscriptionStatusType: LocSubsStatus.FALLOUT,
      })),
      ...unSubscribedLocations.map((loc) => ({
        ...loc,
        subscriptionStatusType: LocSubsStatus.UNSUBSCRIBED,
      })),
    ];
  }, [fallOutSideLocations, unSubscribedLocations]);

  const renderInactiveLocations = () => {
    return (
      <RpVirtualList
        items={inactiveLocations}
        computeItemKey={(index) => {
          const loc = inactiveLocations[index];
          return `${loc.subscriptionStatusType}-${loc.id || index}`;
        }}
        renderItem={(loc) => {
          return (
            <Location
              subscriptionStatusType={loc.subscriptionStatusType}
              is30DaysLeftToJoinCampaign={loc.is30DaysLeftToJoinCampaign}
              loc={loc}
              locFormData={(values as any)?.[loc.id as any]}
              key={loc.id}
              setFieldValue={setFieldValue}
              setFieldError={setFieldError}
              expanded={expanded}
              setExpanded={setExpanded}
              campaign={campaign}
              isUnsubscribed={true}
            />
          );
        }}
      />
    );
  };

  if (isThereNoInactiveLocations) {
    return (
      <>
        <div className="my-5 text-center">
          <Alert severity="info">
            <strong>There is no inactive location.</strong>
          </Alert>
        </div>
      </>
    );
  }

  return (
    <div className="un-subscribed-locations my-5">
      {!isThereNoInactiveLocations &&
        selectedBrand?.id === BRAND_CONST.JINYA_RAMEN_BAR_BRAND_ID && (
          <div className="mb-1 d-flex justify-content-end">
            <Button
              component={Link}
              to="/self-subscribe/jinya-ramen-bar"
              color="primary"
              className="text-case-initial"
              // variant="outlined"
              // startIcon={<Icon>info</Icon>}
            >
              <u>Click here to subscribe your location(s)</u>
            </Button>
          </div>
        )}

      {renderInactiveLocations()}
    </div>
  );
};

export default memo(InActiveLocations);
